import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../contentful.service';
import { Observable } from 'rxjs/Observable';
import { Entry } from 'contentful';


@Component({
  selector: 'app-all-products',
  templateUrl: './all-products.component.html',
  styleUrls: ['./all-products.component.scss']
})
export class AllProductsComponent implements OnInit {

  products: Entry<any>[] = [];

  constructor(private contentful: ContentfulService) { }

  ngOnInit() {
    this.contentful.getProducts()
    .then(products => this.products = products)
    console.log(this.products);

    console.log(this.contentful.getContent('7CYdIOZZxS2C4csoiGEQsw'));

  }

}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/all-products/all-products.component.ts